<template>
  <main class="ml-s min-tablet:min-h-screen max-tablet:ml-0 grow max-w-[800px]">
    <div v-if="!route.meta.embedded" class="flex gap-xs mb-s">
      <NuxtLink
        v-if="$attrs.hasBackButton"
        class="min-tablet:hidden flex self-center text-dark"
        :to="getPagePath['self-service'][locale]"
        :aria-label="$t('dbc-button-back')"
      >
        <DbcSvg name="dbc-icon-chevron-left" />
      </NuxtLink>
      <UtilsHeadline :level="2" :text="headline" />
    </div>
    <slot />
  </main>
</template>
<script setup lang="ts">
const { locale } = useI18n()
const headline = useAttrs().headline as string
const route = useRoute()
</script>
